import { render, staticRenderFns } from "./CampoRecepcionSii.vue?vue&type=template&id=8a5c5830&scoped=true&"
import script from "./CampoRecepcionSii.vue?vue&type=script&lang=js&"
export * from "./CampoRecepcionSii.vue?vue&type=script&lang=js&"
import style0 from "./CampoRecepcionSii.vue?vue&type=style&index=0&id=8a5c5830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5c5830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5c5830')) {
      api.createRecord('8a5c5830', component.options)
    } else {
      api.reload('8a5c5830', component.options)
    }
    module.hot.accept("./CampoRecepcionSii.vue?vue&type=template&id=8a5c5830&scoped=true&", function () {
      api.rerender('8a5c5830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoRecepcionSii.vue"
export default component.exports